import { render, staticRenderFns } from "./BiContactUs.vue?vue&type=template&id=1cf13f2c&"
import script from "./BiContactUs.vue?vue&type=script&lang=ts&"
export * from "./BiContactUs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports